/* istanbul ignore file */
// for reference:
// check out https://auth0.com/blog/role-based-access-control-rbac-and-react-apps/

import { Permission, Role, PermissionRules } from '../types/Auth';

/**
 * Roles:
 * - `Client`, `StuartStaff`
 *
 * Permission types:
 * - `static`, `dynamic`
 *
 * Available operations:
 * - `view`, `edit`, `add`, `delete`
 */
const rules: PermissionRules = {
    [Role.Client]: {
        static: [
            Permission.ADMIN_PAGE_VIEW,
            Permission.CLIENT_PAGE_VIEW,
            Permission.CLIENT_LIST_SECTION_VIEW,
            Permission.CLIENT_FORM_SECTION_VIEW,
            Permission.CLIENT_VIEW,
            Permission.FT_AUTOSTACKING_EDIT,
            Permission.JOB_PAGE_VIEW,
            Permission.JOB_LIST_SECTION_VIEW,
            Permission.JOB_DETAIL_SECTION_VIEW,
            Permission.STACK_LIST_SECTION_VIEW,
            Permission.STACK_DETAIL_SECTION_VIEW,
        ],
    },
    [Role.StuartStaff]: {
        static: [
            Permission.ADMIN_PAGE_VIEW,
            Permission.CLIENT_PAGE_VIEW,
            Permission.CLIENT_LIST_SECTION_VIEW,
            Permission.CLIENT_FORM_SECTION_VIEW,
            Permission.CLIENT_VIEW,
            Permission.CLIENT_ADD,
            Permission.CLIENT_EDIT,
            Permission.CLIENT_DELETE,
            Permission.FT_AUTOSTACKING_ADD,
            Permission.FT_AUTOSTACKING_EDIT,
            Permission.FT_AUTOSTACKING_DELETE,
            Permission.JOB_PAGE_VIEW,
            Permission.JOB_LIST_SECTION_VIEW,
            Permission.JOB_DETAIL_SECTION_VIEW,
            Permission.STACK_LIST_SECTION_VIEW,
            Permission.STACK_DETAIL_SECTION_VIEW,
        ],
    },
    [Role.SE]: {
        static: [
            Permission.ADMIN_PAGE_VIEW,
            Permission.CLIENT_PAGE_VIEW,
            Permission.CLIENT_LIST_SECTION_VIEW,
            Permission.CLIENT_FORM_SECTION_VIEW,
            Permission.CLIENT_VIEW,
            Permission.CLIENT_ADD,
            Permission.CLIENT_EDIT,
            Permission.CLIENT_DELETE,
            Permission.FT_AUTOSTACKING_ADD,
            Permission.FT_AUTOSTACKING_EDIT,
            Permission.FT_AUTOSTACKING_DELETE,
            Permission.JOB_PAGE_VIEW,
            Permission.JOB_LIST_SECTION_VIEW,
            Permission.JOB_DETAIL_SECTION_VIEW,
            Permission.STACK_LIST_SECTION_VIEW,
            Permission.STACK_DETAIL_SECTION_VIEW,
        ],
    },
};

export default rules;
